module.exports = __webpack_public_path__ + "static/media/pp-5.c975c9a5.jpg";